import SlideDown from "react-slidedown/lib/slidedown";

import chevronDown from "../../assets/icons/chevron-down-dark.svg";
import getClassName from "../../utilities/getClassName";
import { useEffect, useState } from "react";

const MoreInfoTray = ({ buttonText, children, open, close, isReportView }) => {
    // State
    const [trayOpen, setTrayOpen] = useState(false);

    // Set tray from parent
    useEffect(() => {
        setTrayOpen(open);
    }, [open, close]);

    return (
        <div className="more-info-tray">
            <button
                onClick={() => setTrayOpen(!trayOpen)}
                className={getClassName(["more-info-tray__button", trayOpen && "more-info-tray__button--open"])}
            >
                {buttonText}

                {!isReportView && <img src={chevronDown} alt="" />}
            </button>

            {isReportView ? (
                <div className="more-info-tray__content-wrapper">
                    <div className="more-info-tray__content">{children}</div>
                </div>
            ) : (
                <SlideDown closed={!trayOpen} className="more-info-tray__slidedown">
                    <div className="more-info-tray__content-wrapper">
                        <div className="more-info-tray__content">{children}</div>
                    </div>
                </SlideDown>
            )}
        </div>
    );
};

export default MoreInfoTray;
